module.exports = __webpack_public_path__ + "img/poker-h01.e08132fa.svg";